import { memo } from 'react';
import { css } from '@emotion/react';
import { CallEvent } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import dayjs from 'dayjs';
import { theme } from '@frontend/theme';
import { Text, Truncated } from '@frontend/design-system';
import { AIReceptionistEventComponent } from '../components/ai/ai-receptionist-accordion-event';
import { Dot } from '../components/dot.component';
import { IVREvent } from '../components/ivr/ivr-accordion-event';
import { VoicemailEvent } from '../components/voicemail/voicemail-accordion-event';

export const formatTime = (date?: string): string => {
  return date ? dayjs(date).format('hh:mm:ss A') : '';
};
interface DotRowProps {
  message: React.ReactNode;
  time: string;
  isLast?: boolean;
}

export const DotRow = memo(({ message, time, isLast }: DotRowProps) => (
  <div css={[styles, !isLast && trailingDotStyles]}>
    <Dot className='dot' size='large' css={{ backgroundColor: theme.colors.neutral50 }} />
    <Truncated textAlign='left' as={Text} size='medium'>
      {message}
    </Truncated>
    <Text as='div' size='medium'>
      {time}
    </Text>
  </div>
));

export const getEventBody = (event: CallEvent, callerName?: string) => {
  if ('ivrEvent' in event) {
    return <IVREvent dtmfEvents={event.ivrEvent.dtmfEvents} callerName={callerName} />;
  }

  if ('voicemailPromptEvent' in event) {
    return (
      <VoicemailEvent
        transcription={event.voicemailPromptEvent.transcription}
        createdAt={event.createdAt}
        callerName={callerName}
      />
    );
  }

  if ('aiReceptionistEvent' in event) {
    return <AIReceptionistEventComponent {...event.aiReceptionistEvent} />;
  }

  return null;
};

DotRow.displayName = 'DotRow';

const styles = css`
  grid-template-columns: max-content 1fr max-content;
  display: grid;
  gap: ${theme.spacing(1)};
  align-items: center;
`;

const trailingDotStyles = css`
  margin-bottom: ${theme.spacing(2)};

  > .dot::after {
    content: '';
    position: absolute;
    top: 115%;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 22px;
    background-image: repeating-linear-gradient(
      to bottom,
      ${theme.colors.neutral50},
      ${theme.colors.neutral50} 5px,
      transparent 5px,
      transparent 8px
    );
  }
`;
